<template>
    <v-container class="my-5">
        <!--    Diálogo  Modal para mostrar mensaje Número de Celular incorrecto    -->
        <v-dialog v-model="dialogCellNumberWrong" max-width="290">
            <v-card>
                <v-card-title class="headline">{{$t('aviso')}}</v-card-title>
                <v-card-text>{{$t('cellphone_wrong')}}</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="dialogCellNumberWrong = false">{{$t('aceptar')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--     Diálogo Modal Persistente para Recortar Logotipo del Fraccionamiento      -->
        <v-dialog v-model="dialogImageLogo" persistent scrollable max-width="800px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        {{$t('recortar_imagen')}}
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <clipper-fixed
                            mode="normal"
                            class="basic lg"
                            ref="clipperImageLogo"
                            :rotate="degrees"
                            :src="imageFrontURL">
                    </clipper-fixed>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-col>
                        <v-row xs12 class="justify-center mr-6">
                            <v-slider
                                    v-model="degrees"
                                    :label="$t('grados')"
                                    step="1"
                                    max="180"
                                    min="-180"
                                    thumb-label="always"
                            ></v-slider>
                        </v-row>
                        <v-row xs12 class="justify-center">
                            <v-btn
                                    color="primary"
                                    @click="getCutingLogo()"
                            >{{$t('recortar')}}</v-btn>
                        </v-row>
                    </v-col>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <h2 class="subheading grey--text">{{$t('Escuelas')}}</h2>
        <v-layout align-center justify-center fill-height>
            <v-dialog v-model="dialog" persistent scrollable max-width="600px">
                <template v-slot:activator="{ on }">
                    <v-btn color="primary" dark v-on="on " @click="update = false, clean_fields()"> + {{$t('agregar_escuela')}}</v-btn>
                </template>
                <v-form
                        @submit.prevent="update ? updateSchool(id_update) : createSchool()">
                    <v-card class="elevation-5">
                        <v-toolbar dark color="primary">
                            <v-toolbar-title>
                                {{$t('Escuelas')}}
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn
                                    class="align-self-end"
                                    color="red"
                                    icon
                                    @click="clear(), dialog = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-card-text>
                            <v-layout row wrap>
                                <v-flex xs12 sm6>
                                    <v-text-field
                                            v-model="name"
                                            v-if="dialog" autofocus
                                            prepend-icon="mdi-home-city"
                                            name="name"
                                            :label="$t('nombre')"
                                            :error-messages="errores.name"
                                    >
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-text-field
                                            v-model="address"
                                            prepend-icon="mdi-map-marker"
                                            name="address"
                                            :label="$t('direccion')"
                                            :error-messages="errores.address"
                                    >
                                    </v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex xs12 sm6>
                                    <v-label>{{$t('telefono')}}</v-label>
                                    <vue-tel-input
                                            class="mt-3 mb-3"
                                            v-model="telephone"
                                            @onInput="onInput"
                                    >
                                    </vue-tel-input>
                                    <v-alert
                                            outlined
                                            v-if="errores.telephone"
                                            type="error"
                                    >
                                        {{errores.telephone}}
                                    </v-alert>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-text-field
                                            v-model="email"
                                            prepend-icon="mdi-email"
                                            name="email"
                                            label="E-Mail"
                                            :error-messages="errores.email"
                                    >
                                    </v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex xs12 sm6 class="edge pt-3 pb-3 pl-3 pr-3">
                                    <v-label>
                                        {{$t('logotipo')}}
                                    </v-label>
                                    <br>
                                    <v-img
                                            class="pt-3 pb-3"
                                            :src="resultLogoURL"
                                            v-if="resultLogoURL"
                                            width="auto"
                                            height="180"
                                    ></v-img>
                                    <br>
                                    <v-btn
                                            color="primary">
                                        <clipper-upload
                                                @input="dialog = false, dialogImageLogo = true, degrees = 0"
                                                accept="image/*"
                                                v-model="imageFrontURL"
                                        >
                                            {{$t('subir_imagen')}}
                                        </clipper-upload>
                                    </v-btn>
                                    <br>
                                    <v-alert
                                            v-if="errores.logo"
                                            type="error"
                                            outlined
                                            transition="scale-transition"
                                    >
                                        {{errores.logo}}
                                    </v-alert>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-text-field
                                            v-model="web_page"
                                            prepend-icon="mdi-web"
                                            name="web_page"
                                            :label="$t('pagina_web')"
                                            :error-messages="errores.web_page"
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex xs12 sm4>
                                    <v-text-field
                                            v-model="url_map"
                                            prepend-icon="mdi-lock"
                                            name="url_map"
                                            :label="$t('url_mapa')"
                                            :error-messages="errores.url_map"
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-alert
                                    :value=alerta
                                    type="warning"
                                    outlined
                                    transition="scale-transition"
                            >
                                Fallo con el Servidor
                            </v-alert>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn color="primary" @click="clear(), dialog = false">{{$t('cerrar')}}</v-btn>
                            <v-spacer/>
                            <v-btn :loading="loading" v-if="update" color="primary" type="submit">{{$t('modificar')}}</v-btn>
                            <v-btn :loading="loading" v-else color="primary" type="submit">{{$t('agregar')}}</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-dialog>
        </v-layout>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-layout class="my-4" align-center justify-center fill-height>
            <v-flex >
                <v-card-title>
                    {{$t('Escuelas')}}
                    <v-spacer></v-spacer>
                    <v-text-field
                            v-model="search"
                            append-icon="mdi-account"
                            :label="$t('Buscar')"
                            single-line
                            hide-details
                    ></v-text-field>
                </v-card-title>
                <v-data-table
                        :headers="headers"
                        :loading="loadingDataSchools"
                        :items="schools"
                        :search="search"
                >
                    <template v-slot:item.logo="{ item }">
                        <v-img  width="100" :src="item.logo"></v-img>
                    </template>
                    <template v-slot:item.action="{ item }">
                        <v-icon
                                medium
                                color="grey"
                                class="mr-2"
                                @click="fill_fields(item), update = true, dialog = true, id_update = item.id"
                        >
                            mdi-account-search
                        </v-icon>
                    </template>
                    <template v-slot:no-results>
                        <v-alert  type="warning">
                            {{$t('ningun_resultado_1')}} "{{ search }}" {{$t('ningun_resultado_2')}}
                        </v-alert>
                    </template>
                </v-data-table>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import {HTTP} from '@/main.js'
import store from '@/store'
import VuejsClipper from 'vuejs-clipper'
import { mapState } from 'vuex'
import Vue from 'vue'

Vue.use(VuejsClipper, {
  components: {
    clipperBasic: 'clipper-basic',
    clipperFixed: 'clipper-fixed',
    clipperUpload: 'clipper-upload'
  }
})

export default {
  name: 'schools',
  data: () => ({
    alerta: false,
    schools: [],
    dialog: false,
    update: false,
    id_update: 0,
    name: '',
    address: '',
    telephone: '',
    email: '',
    logo: '',
    web_page: '',
    url_map: '',
    errores: [],
    search: '',
    headers: [],
    loadingDataSchools: false,
    dialogImageLogo: false,
    imageFrontURL: '',
    resultLogoURL: '',
    resultAuxLogoURL: '',
    band_cellphone: false,
    dialogCellNumberWrong: false,
    loading: false,
    degrees: 0
  }),
  beforeUpdate () {
    this.headers = [
      {
        text: this.$t('acciones'),
        align: 'center',
        value: 'action',
        sortable: false
      },
      {
        text: this.$t('nombre'),
        align: 'left',
        sortable: true,
        value: 'name'
      },
      {
        text: this.$t('direccion'),
        align: 'left',
        sortable: true,
        value: 'address'
      },
      {
        text: this.$t('telefono'),
        align: 'left',
        sortable: true,
        value: 'telephone'
      },
      {
        text: 'E-Mail',
        align: 'left',
        sortable: true,
        value: 'email'
      },
      {
        text: this.$t('logotipo'),
        align: 'left',
        sortable: true,
        value: 'logo'
      },
      {
        text: this.$t('pagina_web'),
        align: 'left',
        sortable: true,
        value: 'web_page'
      },
      {
        text: this.$t('url_mapa'),
        align: 'left',
        sortable: true,
        value: 'url_map'
      }
    ]
  },
  created: function () {
    this.getSchools()
  },
  computed: {
    ...mapState(['language'])
  },
  methods: {
    getSchools () {
      this.loadingDataSchools = true
      HTTP.get('school/', {
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(response => {
        this.schools = response.data
        this.loadingDataSchools = false
      })
      .catch(e => {
        this.loadingDataSchools = false
        console.log(e)
      })
    },
    createSchool () {
      if (this.band_cellphone === true) {
        this.loading = true
        this.errores = []
        const newID = this.$uuid.v4()
        var bodyFormData = new FormData()
        var fileImageFront = null

        bodyFormData.set('name', this.name)
        bodyFormData.set('address', this.address)
        bodyFormData.set('telephone', this.telephone)
        bodyFormData.set('email', this.email.toLowerCase())
        if (this.resultLogoURL !== '' && this.resultLogoURL.length > 6) {
          fileImageFront = this.dataURLtoFile(this.resultLogoURL, 'logo' + newID + '.jpeg')
        }
        bodyFormData.append('logo', fileImageFront)
        bodyFormData.set('web_page', this.web_page)
        bodyFormData.set('url_map', this.url_map)
        HTTP.post('school/', bodyFormData, {
          headers: {
            'Content-Type': 'application/json',
            'Accept-Language': this.language,
            'authorization': 'Token ' + store.getters.getToken
          }
        })
        .then(ok => {
          this.loading = false
          console.log(ok)
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('mensaje_empresa_alta'))
          this.dialog = false
          this.getSchools()
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loading = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errores = error.response.data
          }
        })
      } else {
        this.dialogCellNumberWrong = true
      }
    },
    updateSchool (id) {
      if (this.band_cellphone === true) {
        this.loading = true
        this.errores = []
        var bodyFormData = new FormData()
        var fileImageFront = null
        bodyFormData.set('name', this.name)
        bodyFormData.set('address', this.address)
        bodyFormData.set('telephone', this.telephone)
        bodyFormData.set('email', this.email.toLowerCase())
        if (this.resultLogoURL !== this.resultAuxLogoURL) {
          const newID = this.$uuid.v4()
          if (this.resultLogoURL !== '' && this.resultLogoURL.length > 6) {
            fileImageFront = this.dataURLtoFile(this.resultLogoURL, 'logo_update' + newID + '.jpeg')
          }
          bodyFormData.append('logo', fileImageFront)
        }
        bodyFormData.set('web_page', this.web_page)
        bodyFormData.set('url_map', this.url_map)
        HTTP.put('school/' + id, bodyFormData, {
          headers: {
            'Content-Type': 'application/json',
            'Accept-Language': this.language,
            'authorization': 'Token ' + store.getters.getToken
          }
        })
        .then(ok => {
          this.loading = false
          console.log(ok)
          this.getSchools()
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('mensaje_empresa_modificado'))
          this.dialog = false
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loading = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errores = error.response.data
          }
        })
      } else {
        this.dialogCellNumberWrong = true
      }
    },
    clear () {
      this.alerta = false
      this.errores = []
      this.$store.commit('snackbar_activate_false')
    },
    fill_fields (item) {
      this.name = item.name
      this.address = item.address
      this.telephone = item.telephone
      this.email = item.email
      this.web_page = item.web_page
      this.url_map = item.url_map
      this.resultLogoURL = item.logo
      this.resultAuxLogoURL = item.logo
      this.band_cellphone = true
    },
    customFilter (item, queryText) {
      const textOne = item.nombre.toLowerCase()
      const searchText = queryText.toLowerCase()
      return textOne.indexOf(searchText) > -1
    },
    clean_fields () {
      this.name = ''
      this.address = ''
      this.telephone = ''
      this.email = ''
      this.logo = ''
      this.web_page = ''
      this.url_map = ''
      this.resultLogoURL = ''
      this.resultAuxLogoURL = ''
    },
    getCutingLogo () {
      // console.log('Datos de la imagen = ', this.imageFrontURL.size)
      const canvas = this.$refs.clipperImageLogo.clip() // call component's clip method
      this.resultLogoURL = canvas.toDataURL('image/jpeg', 0.2) // canvas->image
      // console.log(this.resultLogoURL)
      this.dialogImageLogo = false
      this.dialog = true
    },
    dataURLtoFile (dataurl, filename) {
      var arr = dataurl.split(',')
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    },
    onInput ({ number, isValid }) {
      // console.log(number.e164)
      // console.log(isValid)
      // console.log(country)
      this.telephone = number.e164
      this.band_cellphone = isValid
    }
  }
}
</script>

<style scoped>
    .edge {
        border-radius: 8px;
        border-color: #00A1E4 #00A1E4 #00A1E4 #00A1E4;
        border-width: 3px 3px 3px 3px;
        border-style: solid solid solid solid;
    }
    .wrapper{
        width:200px;
        height:200px;
        position: relative;
        margin: 25px auto;
        overflow: hidden;
        border-radius:50%;
        border: 5px solid #00A1E4;
    }
    .wrapper img{
        position: relative;
        width:100%;
        height:auto;
    }
    .splash-info {
        background: #ffffff;
        position: relative;
        z-index: 2;
        margin-bottom: 30px;
        text-align: center;
        font-size:15px;
        font-weight:bold;
    }
</style>
